import { Avatar, GridLegacy as Grid, Typography, useTheme } from '@mui/material'

import React from 'react'

import type { PasswordStrengthRule } from './rules'

type Props = {
  rule: PasswordStrengthRule
  password: string
  showErrors: boolean
}

const PasswordGuidance: React.FC<Props> = ({ rule, password, showErrors }) => {
  const theme = useTheme()
  const color = rule.validator(password)
    ? theme.palette.text.secondary
    : showErrors
      ? theme.palette.error.main
      : 'black'

  return (
    <Grid item xs={6} key={rule.text} display="inline-flex" alignItems="center">
      <Avatar
        sx={{
          width: '8px',
          height: '8px',
          marginRight: '4px',
          backgroundColor: color,
        }}>
        {' '}
      </Avatar>

      <Typography fontSize="small" color={color}>
        {rule.text}
      </Typography>
    </Grid>
  )
}

export default PasswordGuidance
